<div *ngIf="wallpaper" style="background-image: {{wallpaperString}};" class="layer wallpaper-layer wallpaper">
  <img style="display:none" [src]="preload">
</div>